"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/**
 * Convert ReadableStream into an async iterable.
 */
function ReadableStreamtoIterable(readableStream) {
    return tslib_1.__asyncGenerator(this, arguments, function ReadableStreamtoIterable_1() {
        var reader, done, _a, end, value;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    reader = readableStream.getReader();
                    done = false;
                    _b.label = 1;
                case 1:
                    if (!!done) return [3 /*break*/, 6];
                    return [4 /*yield*/, tslib_1.__await(reader.read())];
                case 2:
                    _a = _b.sent(), end = _a.done, value = _a.value;
                    if (end) {
                        done = true;
                        return [3 /*break*/, 6];
                    }
                    if (!value) return [3 /*break*/, 5];
                    return [4 /*yield*/, tslib_1.__await(value)];
                case 3: return [4 /*yield*/, _b.sent()];
                case 4:
                    _b.sent();
                    _b.label = 5;
                case 5: return [3 /*break*/, 1];
                case 6: return [2 /*return*/];
            }
        });
    });
}
exports.ReadableStreamtoIterable = ReadableStreamtoIterable;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXRpbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvdXRpbHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUE7O0dBRUc7QUFDSCxTQUF1Qix3QkFBd0IsQ0FDN0MsY0FBOEI7Ozs7OztvQkFFeEIsTUFBTSxHQUFHLGNBQWMsQ0FBQyxTQUFTLEVBQUUsQ0FBQztvQkFDdEMsSUFBSSxHQUFHLEtBQUssQ0FBQzs7O3lCQUNWLENBQUMsSUFBSTtvQkFDbUIscUNBQU0sTUFBTSxDQUFDLElBQUksRUFBRSxHQUFBOztvQkFBMUMsS0FBdUIsU0FBbUIsRUFBbEMsR0FBRyxVQUFBLEVBQUUsS0FBSyxXQUFBO29CQUN4QixJQUFJLEdBQUcsRUFBRTt3QkFDUCxJQUFJLEdBQUcsSUFBSSxDQUFDO3dCQUNaLHdCQUFNO3FCQUNQO3lCQUNHLEtBQUssRUFBTCx3QkFBSzt5REFDRCxLQUFLO3dCQUFYLGdDQUFXOztvQkFBWCxTQUFXLENBQUM7Ozs7Ozs7Q0FHakI7QUFmRCw0REFlQyIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQ29udmVydCBSZWFkYWJsZVN0cmVhbSBpbnRvIGFuIGFzeW5jIGl0ZXJhYmxlLlxuICovXG5leHBvcnQgYXN5bmMgZnVuY3Rpb24qIFJlYWRhYmxlU3RyZWFtdG9JdGVyYWJsZTxUPihcbiAgcmVhZGFibGVTdHJlYW06IFJlYWRhYmxlU3RyZWFtXG4pOiBBc3luY0l0ZXJhYmxlPFQ+IHtcbiAgY29uc3QgcmVhZGVyID0gcmVhZGFibGVTdHJlYW0uZ2V0UmVhZGVyKCk7XG4gIGxldCBkb25lID0gZmFsc2U7XG4gIHdoaWxlICghZG9uZSkge1xuICAgIGNvbnN0IHsgZG9uZTogZW5kLCB2YWx1ZSB9ID0gYXdhaXQgcmVhZGVyLnJlYWQoKTtcbiAgICBpZiAoZW5kKSB7XG4gICAgICBkb25lID0gdHJ1ZTtcbiAgICAgIGJyZWFrO1xuICAgIH1cbiAgICBpZiAodmFsdWUpIHtcbiAgICAgIHlpZWxkIHZhbHVlO1xuICAgIH1cbiAgfVxufVxuIl19